// extracted by mini-css-extract-plugin
export var closeButton = "_30-0";